import * as Yup from 'yup'

/*
  Configuração global do repasse automático, na área do admin.

  As duas chaves que decidem se dinheiro sai da conta da Cutilei e quanto é retido de quem
  antecipa. A API valida a faixa de novo e devolve `invalid_fee` — o Yup existe para o erro
  aparecer no campo antes de a requisição sair, não para substituir aquela checagem.
*/

/*
  O mesmo teto de `PayoutRules.MAX_FEE_PERCENTAGE`. A tela usa o `maxFeePercentage` que vem na
  resposta para limitar o campo; este número é a trava dura, para o caso de a resposta não
  trazer o campo.
*/
export const MAX_FEE_PERCENTAGE = 50

const payoutConfigValidator = Yup.object ().shape ({
  enabled: Yup.boolean (),

  /*
    PERCENTO (5 = 5%), e não fração — ao contrário de `comission_percentage` no agendamento.
    Zero é uma escolha legítima: antecipar de graça, por decisão comercial.
  */
  anticipationFeePercentage: Yup.number ()
    .typeError ('Informe a taxa de antecipação')
    .required ('Informe a taxa de antecipação')
    .min (0, 'A taxa não pode ser negativa')
    .max (MAX_FEE_PERCENTAGE, `A taxa não pode passar de ${MAX_FEE_PERCENTAGE}%`)
})

export default payoutConfigValidator
